import { AxiosRequestConfig, InternalAxiosRequestConfig } from 'axios'
import { getCookieAuthorizationToken } from '../../../../auth/services/token-service'

export async function authenticatedRequestInterceptor(
  config: AxiosRequestConfig<any>
) {
  const token = getCookieAuthorizationToken()

  config.headers = {
    ...config.headers,
    Authorization: `${token}`
  }

  return config as InternalAxiosRequestConfig
}
